import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router'

function Dashboard() {
  const router = useRouter();
  const { t, c } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  useEffect(() => {
    if (router.isReady) {
      router.replace(`/customerzone/joblist?t=${t}&c=${c}`);
    }
  }, [router.isReady]);

  return <>Redirecting you to jobs</>;
}

export default Dashboard;

export const Route = createFileRoute('/customerzone')({ component: Dashboard })
